import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import ArchiveItem from '../components/ArchiveItem';
import styles from './archive.module.scss';
import getProjects from '../utils/getProjects';

class ArchivePage extends Component {
  state = {
    backgroundIndex: 0,
    currentProject: null,
  };

  componentDidMount () {
    const { data } = this.props;

    // Preload images
    if (data.allContentfulProject.edges) {
      data.allContentfulProject.edges.forEach(project => {
        const { images } = project.node;
        if (images) {
          images.forEach(image => {
            const img = new Image();
            img.src = image.asset.file.url;
          });
        }
      });
    }
  }

  onItemOver = slug => {
    const { data } = this.props;
    const { currentProject } = this.state;
    const projects = data.allContentfulProject.edges.map(({ node }) => node);

    this.projectToEnter = slug;
    if (!currentProject || slug !== currentProject.slug) {
      const newProject = projects.find(project => project.slug === slug);
      this.setState({
        currentProject: newProject,
      });
      this.imageInterval = setInterval(() => {
        this.setState({
          backgroundIndex: this.state.backgroundIndex + 1,
        });
      }, 400);
    }
  }

  onItemLeave = slug => {
    this.projectToEnter = null;

    setTimeout(() => {
      this.shouldClear(slug);
    }, 10);
  }

  projectToEnter = null;

  shouldClear = slug => {
    if (!this.projectToEnter || slug !== this.projectToEnter) {
      this.setState({
        backgroundIndex: 0,
        currentProject: null,
      });
      clearInterval(this.imageInterval);
    }
  }

  render() {
    const { data } = this.props;
    const { backgroundIndex, currentProject } = this.state;
    const projects = getProjects(data.allContentfulProject.edges);
    const projectImages = currentProject && currentProject.images;
    const backgroundImage = projectImages && projectImages[backgroundIndex % projectImages.length];

    return (
      <div>
        <Header background={!backgroundImage} />
        <div className={styles.imageWrapper}>
          {backgroundImage &&
            <img
              alt={backgroundImage.title}
              key={backgroundImage.title}
              src={backgroundImage.asset.file.url}
            />
          }
        </div>
        <ul className={styles.list}>
          {projects.map(project => (
            <li key={project.slug}>
              <ArchiveItem
                onLeave={this.onItemLeave}
                onOver={this.onItemOver}
                {...project}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

ArchivePage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ArchivePage;

export const query = graphql`
  query ArchiveQuery {
    allContentfulProject(sort: { fields: [date] }) {
      edges {
        node {
          attribution {
            label
            url
          }
          buyLink
          client
          date
          description
          dimensions
          material
          medium
          title
          slug
          status
          images {
            __typename
            ... on ContentfulProjectImage {
              title
              fullscreen
              asset {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/archive.jsx